import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { Hotkey } from 'ui-components/components/hotkey';

const messages = defineMessages({
  name: {
    description: 'quickSearchHotkey.focus',
    defaultMessage: 'Focus QuickSearch',
    id: 'Xlqtr7',
  },
});

const QuickSearchFocusHotkey = ({ children, onFocusQuickSearch }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      displayHotkeyStrings: ['/'],
      hotkey: ['/'],
      barcode: '+N8MDA2VZ6AND=',
      handler: onFocusQuickSearch,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
    }),
    [intl, onFocusQuickSearch],
  );

  return <Hotkey hotkey={hotkeyMetadata}>{children}</Hotkey>;
};

QuickSearchFocusHotkey.propTypes = {
  children: PropTypes.node.isRequired,
  onFocusQuickSearch: PropTypes.func.isRequired,
};

export default QuickSearchFocusHotkey;
